// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Contas_GetContasDisponiveisInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /contas/contas/get_contas_disponiveis/{franquia_id}
 *
 * No body required — franquia_id is a URL path parameter.
 */
import { registerContract } from './validate'

export interface Contas_GetContasDisponiveisInput {}

registerContract('Contas_GetContasDisponiveisInput', {})
